import { faBan, faWarning } from '@fortawesome/pro-regular-svg-icons'
import { Alert } from '@mantine/core'

import {
  useMutationCancelBooking,
  useQueryGetBookingById,
} from '@flecto/core/saas'
import { useTranslation } from '@flecto/translations'
import { type ParameterID } from '@flecto/types'
import { Modal, Icon, useNotifications } from '@flecto/ui'

import { CardBookingQuickDetails } from '../../../bookings'

export type ModalBookingActionCancelProps = {
  bookingId?: ParameterID
  onSuccess?: () => void
}

export function ModalBookingActionCancel({
  bookingId,
  onSuccess,
}: ModalBookingActionCancelProps) {
  const { t } = useTranslation('saas', { keyPrefix: 'booking_actions' })
  const { t: tActions } = useTranslation('shared', { keyPrefix: 'actions' })

  const { data: booking } = useQueryGetBookingById({ bookingId })

  const { mutateAsync: cancelBooking, isLoading } = useMutationCancelBooking()

  const { showNotification } = useNotifications()

  const handleSubmit = async () => {
    try {
      await cancelBooking({ bookingId })
      showNotification({
        type: 'success',
        message: t('notification_action_cancel_success'),
      })
      onSuccess?.()
    } catch {
      showNotification({
        type: 'error',
        message: t('notification_action_cancel_error'),
      })
    }
  }

  return (
    <Modal size='md'>
      <Modal.Close />
      <Modal.Icon icon={faBan} color='red' withCircleBackground />
      <Modal.Title>{t('modal_action_cancel_title')}</Modal.Title>
      <Modal.Content>
        {booking?.insured && booking.meta?.has_issued_insurances && (
          <Alert color='orange' icon={<Icon icon={faWarning} />} mb='md'>
            {t('modal_action_cancel_alert_description_with_insurances')}
          </Alert>
        )}
        <CardBookingQuickDetails
          bookingId={bookingId}
          previewNewBookingStatus='canceled'
        />
      </Modal.Content>
      <Modal.Cancel />
      <Modal.Submit color='red' onClick={handleSubmit} loading={isLoading}>
        {tActions('confirm')}
      </Modal.Submit>
    </Modal>
  )
}
